import script from "./TradingAccountIndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingAccountIndexView.vue?vue&type=script&setup=true&lang=js"

import "./TradingAccountIndexView.vue?vue&type=style&index=0&id=32e6e064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e6e064"]])

export default __exports__